import { Button, Input, InputGroup, InputRightElement } from '@chakra-ui/react'
import React, { FC } from 'react'

interface SearchInputProps {
  value: string
  onChange: (text: string) => void
  placeholder?: string
}

const SearchInput: FC<SearchInputProps> = ({ value, onChange, placeholder }) => {
  return (
    <InputGroup>
      <Input
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        backgroundColor='white'
      />
      {value && (
        <InputRightElement>
          <Button variant='outline' size='sm' onClick={() => onChange('')}>
            X
          </Button>
        </InputRightElement>
      )}
    </InputGroup>
  )
}

export default SearchInput
